var map = {
	"./BuddhaAkshay/images/SideBarLastIcon.svg": [
		19082,
		82
	],
	"./JanBhavishya/images/SideBarLastIcon.svg": [
		90939,
		939
	],
	"./Suvarna/images/SideBarLastIcon.svg": [
		43561,
		561
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 95343;
module.exports = webpackAsyncContext;